import React, { FC } from 'react';
import { BrowserRouter as Router, Outlet, Route, Routes } from 'react-router-dom';
import { Home } from './components/Home';
import { EventDetail } from './components/EventDetail';
import { DisciplineLive } from './components/DisciplineLive';
import { Header } from './components/helpers/Header';
import { Contact } from './components/Contact';

export const AppRouter: FC = () => {
    return (
        <Router>
            <Routes>
                <Route
                    element={
                        <Header>
                            <Outlet />
                        </Header>
                    }
                >
                    <Route path="/" element={<Home />} />
                    <Route path="/event/:eventName" element={<EventDetail />} />
                    <Route path="/event/:eventName/discipline/:disciplineName" element={<DisciplineLive />} />
                    <Route path="/contact" element={<Contact />} />
                </Route>
            </Routes>
        </Router>
    );
};
